!(function () {
  function e() {
    let e = document.querySelector(".cartDrawer__footerSubtotalMoney");
    if (e) {
      e.innerHTML = e.innerHTML.replace("NIS", "₪");
      if (document.documentElement.lang !== 'he'){
        const b = e.innerHTML.split(' ');
        e.innerHTML = [b[1], b[0]].join(' ');
      }
    }
    let t = document.querySelectorAll(".cartDrawer__productPrice");
    t.length && t.forEach((e) => {
      e.innerHTML = e.innerHTML.replace("NIS", "₪");
      const b = e.innerHTML.split(' ');
      if (document.documentElement.lang !== 'he'){
        e.innerHTML = [b[1], b[0]].join(' ');  
      }
    });
  }
  var t = "data-section-id";
  function r(e, r) {
    (this.container = (function (e) {
      if (!(e instanceof Element)) throw TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
      if (null === e.getAttribute(t)) throw Error("Theme Sections: The section container provided does not have an id assigned to the data-section-id attribute.");
      return e;
    })(e)),
      (this.id = e.getAttribute(t)),
      (this.extensions = []),
      Object.assign(
        this,
        (function (e) {
          if ((void 0 !== e && "object" != typeof e) || null === e) throw TypeError("Theme Sections: The properties object provided is not a valid");
          return e;
        })(r)
      ),
      this.onLoad();
  }
  (r.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function (e) {
      this.extensions.push(e);
      var t = Object.assign({}, e);
      delete t.init, Object.assign(this, t), "function" == typeof e.init && e.init.apply(this);
    },
  }),
    "function" != typeof Object.assign &&
      Object.defineProperty(Object, "assign", {
        value: function (e) {
          if (null == e) throw TypeError("Cannot convert undefined or null to object");
          for (var t = Object(e), r = 1; r < arguments.length; r++) {
            var o = arguments[r];
            if (null != o) for (var n in o) Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
          }
          return t;
        },
        writable: !0,
        configurable: !0,
      });
  var o = "data-section-type";
  (window.Shopify = window.Shopify || {}), (window.Shopify.theme = window.Shopify.theme || {}), (window.Shopify.theme.sections = window.Shopify.theme.sections || {});
  var n = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
    a = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
  function c(e) {
    var t = [];
    if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var r = e[0];
    return (
      e instanceof Element || r instanceof Element
        ? l(e).forEach(function (e) {
            t = t.concat(
              a.filter(function (t) {
                return t.container === e;
              })
            );
          })
        : ("string" != typeof e && "string" != typeof r) ||
          s(e).forEach(function (e) {
            t = t.concat(
              a.filter(function (t) {
                return t.type === e;
              })
            );
          }),
      t
    );
  }
  function i(e) {
    for (var t, r = 0; r < a.length; r++)
      if (a[r].id === e) {
        t = a[r];
        break;
      }
    return t;
  }
  function s(e) {
    return (
      "*" === e
        ? (e = Object.keys(n))
        : "string" == typeof e
        ? (e = [e])
        : e.constructor === r
        ? (e = [e.prototype.type])
        : Array.isArray(e) &&
          e[0].constructor === r &&
          (e = e.map(function (e) {
            return e.prototype.type;
          })),
      e.map(function (e) {
        return e.toLowerCase();
      })
    );
  }
  function l(e) {
    return (
      NodeList.prototype.isPrototypeOf(e) && e.length > 0 ? (e = Array.prototype.slice.call(e)) : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e ? (e = []) : !Array.isArray(e) && e instanceof Element && (e = [e]), e
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (e) {
      var t,
        r,
        i = e.detail.sectionId,
        d = e.target.querySelector('[data-section-id="' + i + '"]');
      null !== d &&
        ((t = d.getAttribute(o)),
        (r = d),
        (t = s(t)),
        void 0 === r && (r = document.querySelectorAll("[data-section-type]")),
        (r = l(r)),
        t.forEach(function (e) {
          var t = n[e];
          void 0 !== t &&
            (r = r.filter(function (r) {
              return !(c(r).length > 0 || null === r.getAttribute(o) || (r.getAttribute(o) === e && (a.push(new t(r)), 1)));
            }));
        }));
    }),
    document.addEventListener("shopify:section:unload", function (e) {
      var t = e.detail.sectionId,
        r = e.target.querySelector('[data-section-id="' + t + '"]');
      "object" == typeof c(r)[0] &&
        c(r).forEach(function (e) {
          var t = a
            .map(function (e) {
              return e.id;
            })
            .indexOf(e.id);
          a.splice(t, 1), e.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (e) {
      var t = i(e.detail.sectionId);
      "object" == typeof t && t.onSelect(e);
    }),
    document.addEventListener("shopify:section:deselect", function (e) {
      var t = i(e.detail.sectionId);
      "object" == typeof t && t.onDeselect(e);
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var t = i(e.detail.sectionId);
      "object" == typeof t && t.onBlockSelect(e);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
      var t = i(e.detail.sectionId);
      "object" == typeof t && t.onBlockDeselect(e);
    }));
  let d = "cart-drawer";
  if (d in Shopify.theme.sections.registered)
    document.querySelectorAll("[data-section-type=cart-drawer]").forEach((e, t) => {
      if (0 !== t) {
        let r = e.querySelector("link"),
          o = e.querySelector("script");
        r && r.remove(), o && o.remove();
      }
    });
  else {
    let u = {
        cartDrawerHeader: ".header__cartDrawer",
        cartCount: ".header__cartDrawerItems",
        cartDrawer: ".cartDrawer",
        cartDrawerContent: ".cartDrawer__content",
        drawerClose: ".cartDrawer__close",
        backgroundChange: ".cartDrawer--close",
        productCart: ".cartDrawer__products .cartDrawer__product",
        productRemove: ".cartDrawer__product",
        removeBtn: ".cartDrawer__productRemove",
        productQty: ".cartDrawer__productQty",
        productQtyInput: ".cartDrawer__qtyNum",
        qtyPlus: ".cartDrawer__qtyPlus",
        qtyMinus: ".cartDrawer__qtyMinus",
        productAddBtn: ".cartDrawer__productAlso .cartDrawer__formButton",
        variantPrice: ".cartDrawer__productPrice",
        productSelect: ".productIdSelect--js",
        allButtons: ".cartDrawer__btn",
        content: ".cartDrawer__content",
        subtotal: ".cartDrawer__footerSubtotal",
      },
      p = () => {
        let t = document.querySelectorAll(u.cartDrawerHeader),
          r = document.querySelector(u.cartDrawer),
          o = document.querySelector(u.drawerClose),
          n = document.querySelector(u.backgroundChange),
          a = document.querySelectorAll(u.cartCount);
        async function c(e, t) {
          let r = await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: { [e]: t } }) });
          if (!r.ok) throw Error("Problem with the server. Try to reload the page");
          let o = await r.json();
          window.theme.drawCart(o.item_count);
        }
        function i() {
          let e = document.querySelectorAll(u.removeBtn),
            t = document.querySelectorAll(u.qtyPlus),
            r = document.querySelectorAll(u.qtyMinus),
            o = document.querySelectorAll(u.productAddBtn),
            n = document.querySelectorAll(u.allButtons);
          t.forEach((e) => {
            e.addEventListener("click", (t) => {
              let r = e.parentNode.querySelector("input"),
                o = t.currentTarget.closest(u.productRemove).dataset.id;
              (r.value = +r.value + 1), c(o, r.value);
            });
          }),
            r.forEach((e) => {
              e.addEventListener("click", (t) => {
                let r = e.parentNode.querySelector("input"),
                  o = t.currentTarget.closest(u.productRemove).dataset.id;
                (r.value = +r.value - 1), c(o, r.value);
              });
            }),
            e.forEach((e) => {
              e.addEventListener("click", (e) => {
                e.preventDefault(), c(e.currentTarget.closest(u.productRemove).dataset.id, 0);
              });
            }),
            // o.forEach((e) => {
            //   e.addEventListener("click", (t) => {
            //     t.preventDefault(),
            //       (async function (e) {
            //         (await fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: e, quantity: 1 }] }) })).ok ||
            //           console.error("Error:", error),
            //           window.theme.drawCart();
            //       })(e.parentNode.querySelector(u.productSelect).value);
            //   });
            // }),
            o.forEach((e) => {
              e.addEventListener("click", (t) => {
                debugger;
                 t.preventDefault(),
                  (async function (e) {
                    debugger;
                  const form = t.target.closest('form');
                  if (form){
                    debugger;
                    const config = fetchConfig('javascript');
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';
                    delete config.headers['Content-Type'];
                    const formData = new FormData(form);
                    config.body = formData;
                  
                      (await fetch(window.Shopify.routes.root + "cart/add.js", config)).ok ||
                      console.error("Error:", error),
                      window.theme.drawCart();
                  } else {
                    (
                    await fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: e, quantity: 1 }] }) })).ok ||
                    console.error("Error:", error),
                    window.theme.drawCart();
                  }
                })(e.parentNode.querySelector(u.productSelect).value);
              });
            }),
            n.forEach((e) => {
              e.addEventListener("click", () => {
                n.forEach((e) => {
                  e.classList.add("disabled");
                });
              });
            });
        }
        t.forEach((e) => {
          e.addEventListener("click", () => {
            r.classList.add("active"), n.classList.add("active");
          });
        }),
          o.addEventListener("click", () => {
            r.classList.remove("active"), n.classList.remove("active");
          }),
          n.addEventListener("click", () => {
            r.classList.remove("active"), n.classList.remove("active");
          }),
          i(),
          a.forEach((e) => {
            "0" == e.innerText
              ? t.forEach((e) => {
                  e.classList.add("disabled");
                })
              : t.forEach((e) => {
                  e.classList.remove("disabled");
                });
          }),
          (window.theme.drawCart = async function (r) {
            let o = await (async () => {
                try {
                  let e = await fetch(`${window.Shopify.routes.root}cart.js`);
                  return await e.json();
                } catch (t) {
                  console.log("Error", t);
                }
              })(),
              n = await fetch("?section-id=cart-drawer");
            if (!n.ok) throw Error("Problem with the server. Try to reload the page");
            let c = await n.text(),
              progressbar = document.querySelectorAll('progress-bar'),
              s = new DOMParser().parseFromString(c, "text/html"),
              l = document.querySelector(u.content),
              d = s.querySelector(u.content),
              p = document.querySelector(u.subtotal),
              f = s.querySelector(u.subtotal);
              if (progressbar) {
                  progressbar.forEach(x => x.dispatchEvent(new CustomEvent('update', {
                      detail: { cart: o }
                  })));
              }
            o.item_count > 0
              ? (a.forEach((e) => {
                  e.innerHTML = o.item_count;
                }),
                t.forEach((e) => {
                  e.classList.remove("disabled");
                }))
              : (a.forEach((e) => {
                  e.innerHTML = o.item_count;
                }),
                t.forEach((e) => {
                  e.classList.add("disabled");
                })),
              l && d && ((l.innerHTML = d.innerHTML), (p.innerHTML = f.innerHTML), i()),
              e();
          });
      },
      f = () => {};
    !(function (e, t) {
      if (void 0 !== n[e]) throw Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
      function o(e) {
        r.call(this, e, t);
      }
      (o.constructor = r), (o.prototype = Object.create(r.prototype)), (o.prototype.type = e), (n[e] = o);
    })(d, {
      async onLoad() {
        p();
      },
      onUnload() {
        f();
      },
    });
  }
  e();
})();





// Automatically Open Cart Drawer When Item Added To Cart

 $(document).ready(function() {
  // Open cart drawer after add to cart button is clicked
  $('.productSection__formButton').on('click', function(){
    setTimeout(function(){ $('.header__cartDrawer ').click() }, 2000);
  });
});


